import { PDFDownloadLink } from "@react-pdf/renderer";
import ReportPDF from "./RepasseReportPDFRealizadoDetailsNormal.js";
import { getCurrentDateTime } from "../utils/getCurrentDateTime.js";

const DownloadButton = ({ dataPayments, rawData }) => {
  const currentDateTime = getCurrentDateTime();
  const fileName = `relatorio_empresa_realizante_administrativo_${currentDateTime}.pdf`;

  const title = "Relatório Empresa Realizante (Administrativo)"

  return (
    <PDFDownloadLink
      document={<ReportPDF payment={dataPayments} data={rawData || []} title={title} />}
      fileName={fileName}>
      {({ loading }) =>
        loading ? "Gerando PDF..." : "Baixar PDF detalhes (ADMINISTRATIVO)"
      }
    </PDFDownloadLink>
  );
};

export default DownloadButton;
